import { makeApiRequests } from './api';
import { ENDPOINTS } from './constants';
import { userHasAnyRole } from './roleHelpers';

export const validContactId = value => typeof value === 'string' && /^[a-f0-9]{24}$/i.test(value) ? value : null;
export const canUseTopProducer = () => userHasAnyRole('Super Admin','Admin','Sales','Sales Manager','Sales and Inventory Manager');
export const producerState = state => ({
  view: ['today','pipeline','money'].includes(state?.view) ? state.view : 'today',
  storeId: validContactId(state?.storeId) || 'all',
  managerId: validContactId(state?.managerId) || 'all',
  userId: validContactId(state?.userId) || 'all'
});
export const classicViewLink = (contactId, state) => ({pathname:'/pipeline/crm',state:{contactId:validContactId(contactId),producer:producerState(state)}});
export const producerViewLink = (contactId, state) => ({pathname:'/top-producer-view',state:{contactId:validContactId(contactId),producer:producerState(state)}});

// Use the normal authenticated, access-filtered search route for a transferred selection.
export async function fetchPermittedContact(id, signal) {
  if (!validContactId(id)) return null;
  const {response,error}=await makeApiRequests({endpoint:ENDPOINTS.CONTACTS_SEARCH_NEW,requestBody:{filter:{_id:id},populate:false,pageSize:1},signal});
  if (error) throw new Error(error);
  return response?.results?.find(contact => String(contact._id) === id) || null;
}
